// extracted by mini-css-extract-plugin
module.exports = {"gridItemHero":"GridItemHero--gridItemHero--1dP_W","inner":"GridItemHero--inner--3t2Pp","heading":"GridItemHero--heading--1jWBc","description":"GridItemHero--description--32ZdD"};